export default __webpack_public_path__ + "static/media/mail-bounced-colored.da9f7062.svg";